/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SolveResponse
 */
export interface SolveResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SolveResponse
     */
    correct: boolean;
    /**
     * 
     * @type {number}
     * @memberof SolveResponse
     */
    solutionAttempts: number;
    /**
     * 
     * @type {boolean}
     * @memberof SolveResponse
     */
    solved: boolean;
}

/**
 * Check if a given object implements the SolveResponse interface.
 */
export function instanceOfSolveResponse(value: object): value is SolveResponse {
    if (!('correct' in value) || value['correct'] === undefined) return false;
    if (!('solutionAttempts' in value) || value['solutionAttempts'] === undefined) return false;
    if (!('solved' in value) || value['solved'] === undefined) return false;
    return true;
}

export function SolveResponseFromJSON(json: any): SolveResponse {
    return SolveResponseFromJSONTyped(json, false);
}

export function SolveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'correct': json['correct'],
        'solutionAttempts': json['solutionAttempts'],
        'solved': json['solved'],
    };
}

export function SolveResponseToJSON(json: any): SolveResponse {
    return SolveResponseToJSONTyped(json, false);
}

export function SolveResponseToJSONTyped(value?: SolveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'correct': value['correct'],
        'solutionAttempts': value['solutionAttempts'],
        'solved': value['solved'],
    };
}

